var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress__bar"},[_c('div',{staticClass:"progress__bar--current",style:([`width:${_vm.percentage};`])})]),_c('div',{staticClass:"progress__percentage"},[_vm._v(_vm._s(_vm.percentage))])])
}
var staticRenderFns = []

export { render, staticRenderFns }